import TeaserSmall from '@/elements/widgets/Teaser/Small/TeaserSmall'
import { WidgetTeaserProps } from '@/types/cms'
import AppContext from '@/types/context'
import { AreaItem } from '@/types/cms/AreaItem'

const TeaserSmallInline = ({ item, context }: { item: WidgetTeaserProps | AreaItem; context: AppContext }) => {
  return <TeaserSmall item={item} context={context} inline />
}

export default TeaserSmallInline
